import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {SharedModule} from './shared/shared.module';
import {AppStateReducer} from './store/app.reducer';
import {AppStateEffects} from './store/app.effects';
import {environment} from '../environments/environment';
import {TranslationModule} from './translation/translation.module';
import {PushNotificationService} from './services/push-notification.service';
import {CodeSelectPageModule} from './pages/code-select/code-select.module';
import {httpInterceptorProviders} from './interceptors';
import {IonicGestureConfig} from './services/gestures.service';
import {AppVersionService} from './services/app-version.service';
import {APP_CONFIG_TOKEN, AppConfigService} from './services/appconfig.service';
import {AuthEffects} from './store/auth/auth.effects';
import {LoadingService} from './services/loading.service';

import * as Sentry from '@sentry/browser';
import {SentryErrorHandler} from './interceptors/sentryIonicErrorHandler';
import {PdfManagerService} from './services/pdf-manager.service';
import {Crop} from '@ionic-native/crop/ngx';
import {RtcService} from './services/rtc.service';
import {SoundService} from './services/sound.service';
import {ReservationsService} from './services/reservations.service';
import {CompanyService} from './services/company.service';
import {SMS} from '@awesome-cordova-plugins/sms/ngx';
import {SmsRetriever} from '@awesome-cordova-plugins/sms-retriever/ngx';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/messaging';

import {DesktopNotificationService} from './services/desktop-notification.service';
import {FieldFormatPipe} from './pipes/field-format.pipe';

Sentry.init({
  environment: environment.name,
  dsn: 'https://0678ab3856270ee60fae2390d154580b@o4507294665801728.ingest.de.sentry.io/4507298597306448',
});

(document as any).fbApp = firebase.initializeApp(environment.firebaseConfig);

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            innerHTMLTemplatesEnabled: true
        }),
        AppRoutingModule,
        SharedModule.forRoot(),
        HttpClientModule,
        StoreModule.forRoot({ AppStateReducer }),
        EffectsModule.forRoot([AppStateEffects, AuthEffects]),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
        }),
        TranslationModule.forRoot({
            apiUrl: environment.translationApiUrl,
        }),
        CodeSelectPageModule
    ],
    providers: [
        FieldFormatPipe,
        DesktopNotificationService,
        PushNotificationService,
        SoundService,
        LoadingService,
        RtcService,
        httpInterceptorProviders,
        ReservationsService,
        CompanyService,
        AppVersionService,
        PdfManagerService,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: IonicGestureConfig
        },
        AppConfigService,
        { provide: APP_CONFIG_TOKEN, useValue: environment },
        SMS,
        { provide: ErrorHandler, useClass: SentryErrorHandler },
        Crop,
        SmsRetriever
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
